import React,{useState,useEffect} from 'react'
import Navbar from './Navbar'
import Footer from './Footer'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import './payment.css'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCardIcon from '@mui/icons-material/AddCard';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom';
import { formatRupiah,alertsucces } from '../all/allFunction';

const Payment = () => {
    const token = localStorage.getItem('accessToken');
    const [manualpay,setManualpay] = useState([]);
    const {transaksiId} = useParams()
    const [error,setError] = useState('')
    const navigate = useNavigate()
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false)
    const [keterangan,setKeterangan] = useState('')
    const [msgError,setMsgError] = useState({
      file:'',
      keterangan:''
    })
    
    

    useEffect(() => {
      const payment = async () => {
        if (!token) {
          return navigate('/login');
        }
        try {
          const response = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/auth/manualPayment`, {
            params: { transaksiId },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setManualpay(response.data);
        } catch (error) {
          if (error.response?.status === 404) {
            return setError(error.response.data.message);
          }
          console.error(error);
        }
      };
    
      payment();
    }, [token, transaksiId, navigate]);

    
    const handleSubmit = async (e) => {
      e.preventDefault(); 
      setLoading(true)
      const maxSize = 2 * 1024 * 1024;
      if(selectedFile.size > maxSize) {
        setLoading(false)
         setMsgError(p => ({...p,file:'File size tidak boleh lebih dari 2MB'}))
         return
      }
      if(keterangan.length >= 250) {
        setLoading(false)
        setMsgError(p => ({...p,keterangan:'Keterangan maksimal 250 kata'}))
        return 
      }
      const formData = new FormData();
      formData.append("image",selectedFile);
      formData.append("keterangan", keterangan);
      formData.append("id", transaksiId);
      formData.append('amount',totalPembeli())

      try {
      const response =  await axios.post(`${process.env.REACT_APP_URL_BACKEND}/auth/upload`,formData,{
          headers: { "Content-Type":"multipart/form-data"},
        })
        setLoading(false)
        alertsucces('Berhasil','Bukti pembayaran anda sedang ditinjau.','success')
        navigate(`/transaksi/${transaksiId}`)
      } catch (error) {
        setLoading(false)
        alertsucces('Gagal',error.response.data.error,'error')
        console.error(error)
      }
    }

    const totalPembeli = () => {
      const amountValue = parseFloat(manualpay.transactions[0].amount);
      const adminFee = parseFloat(manualpay.transactions[0].admin_fee)
      
      switch (manualpay.transactions[0].admin_paid_by) {
          case 'Pembeli' : return amountValue + adminFee;
          case '50%/50%' : return amountValue + (adminFee / 2);
          default : return amountValue;
      }
  }

  const handleFileChange = (event) => {
    const file = event.target.files[0]; // Ambil file pertama
    setSelectedFile(file);
  };
  
  const sendBukti = () => {
    const url = `/transaksi/${transaksiId}`;
    window.open(url, '_blank');
  }

    const style = {
        color:'#D9D9D9'
      }
  return (
    <div id='transaksi-saya'>
        <Navbar/>
        <div  style={{width:'60rem',maxWidth:'100%',margin:'0 auto',paddingTop:'4rem',paddingBottom:'2rem',overflowX: 'hidden'
    }} className='payment-method'>{manualpay.length === 0 ? (<p>{error}</p>) :<div> {manualpay.transactions[0].Payment === 'Proses' ? 
   (<><p style={{color:'black',padding:'2rem 1rem 0 1rem'}}>Pembayaran Anda sedang ditinjau. Harap tunggu hingga proses verifikasi selesai.</p>
   <div style={{display:"flex",alignItems:'center',justifyContent:'center'}}><button onClick={sendBukti} style={{
       textDecoration: 'none',
       padding: '8px',
       borderRadius: '5px',
       backgroundColor: '#3cb95d',
       fontWeight: '600',
       gap: '0.5rem',
       width: '12rem',
       border: 'none',
       fontSize: '1rem',
       marginTop: '1rem',
     }}>kembali Ke Transaksi</button></div></>) : (<div>
      <Accordion  style={{color:'black'}}>
       <AccordionSummary
         expandIcon={<ExpandMoreIcon style={{fill:'black'}} />}
         aria-controls="panel1-content"
         id="panel1-header"
       >
           <div style={{display:'flex',alignItems:'center',gap:'0.5rem',padding:'0.3rem 0'}}>
               <ShoppingCartCheckoutIcon style={{fill:'#545454',alignItems:'center'}} />
       <p style={{color:'#545454',fontWeight:'600'}}>RINGKASAN TRANSAKSI</p>
       </div>
       </AccordionSummary>
       <AccordionDetails>
         <Typography style={{color:'#545454',padding:'1.5rem 1re'}}>
         <p style={{color:"#545454",fontWeight:'600'}} >Deskripsi</p>
         <p style={{color:'#545454'}}>Transaksi ID : {transaksiId}</p>
         <p style={{color:'#545454'}}>Barang/Jasa : Rekber {manualpay.transactions[0].product}</p>
         <p style={{color:'#545454'}}>Total : {formatRupiah(totalPembeli())}</p>
         </Typography>
       </AccordionDetails>
     </Accordion>
     <div style={{display:'flex',justifyContent:'center', flexDirection:'column',alignItems:'center',margin:'2rem 0 3rem 0'}}>
       <p style={{color:'black',fontWeight:'600',marginBottom:'1rem'}}>JUMLAH TOTAL</p>
       <p style={{color:'black',fontSize:'2rem'}}>{formatRupiah(totalPembeli())}</p>
     </div>
     <div style={{margin:' 0 1rem'}}>

       <p style={{color:'black',marginBottom:"1rem"}}>METODE PEMBAYARAN</p>
       <div>
       <Accordion style={style}>
       <AccordionSummary
         expandIcon={<ExpandMoreIcon style={{fill:'black'}} />}
         aria-controls="panel1-content"
         id="panel1-header"
       >
       <div style={{display:'flex',alignItems:'center',gap:'0.5rem'}}>
       <AddCardIcon style={{fill:'#545454',alignItems:'center'}}/>
       <p style={{color:'#545454',alignItems:'center'}}>Virtual Account</p>
       </div>
       </AccordionSummary>
       <AccordionDetails>
         <Typography style={{color:'#545454'}}>
          {manualpay.length === 0 ? (
           <p>Nomor rekening tidak di temukan</p>
          ) : (manualpay.manual_va.map((payment) => (
           <div key={payment.id} style={{marginBottom:'1rem'}}>
             <p>BANK : {payment.bank_name}</p>
             <p>NO REK : {payment.account_number}</p>
             <p>A/N : {payment.account_holder_name}</p>
           </div>
          )))}
         </Typography>
       </AccordionDetails>
     </Accordion>
     <Accordion style={style}>
       <AccordionSummary
         expandIcon={<ExpandMoreIcon style={{fill:'black'}} />}
         aria-controls="panel1-content"
         id="panel1-header"
       >
           <div style={{display:'flex',alignItems:'center',gap:'0.5rem'}}>
       <PhoneAndroidIcon style={{fill:'#545454',alignItems:'center'}}/>
       <p style={{color:'#545454'}}>E-Wallet</p>
       </div>
       </AccordionSummary>
       <AccordionDetails>
         <Typography style={{color:'#545454'}}>
         {manualpay.length === 0 ? (
           <p>Nomor rekening tidak di temukan</p>
          ) : (manualpay.manual_ewallet.map((payment) => (
           <div key={payment.id} style={{marginBottom:'1rem'}}>
             <p>E-WALLET : {payment.bank_name}</p>
             <p>NO REK : {payment.account_number}</p>
             <p>A/N : {payment.account_holder_name}</p>
           </div>
          )))}
         </Typography>
       </AccordionDetails>
     </Accordion>
     <Accordion style={style}>
       <AccordionSummary
         expandIcon={<ExpandMoreIcon style={{fill:'black'}} />}
         aria-controls="panel1-content"
         id="panel1-header"
       >
           <div style={{display:'flex',alignItems:'center',gap:'0.5rem'}}>
               <QrCodeScannerIcon style={{fill:'#545454',alignItems:'center'}} />
       <p style={{color:'#545454'}}>Pembayaran QR</p>
       </div>
       </AccordionSummary>
       <AccordionDetails>
         <Typography style={{color:'#545454'}}>
          <p style={{color:'#545454'}} >Akan Segera Hadir</p>
         </Typography>
       </AccordionDetails>
     </Accordion>
       </div>
       <p style={{marginTop:'2rem', marginBottom:'1rem'}}>SILAHKAN LAKUKAN PEMBAYARAN ANDA SESUAI DENGAN NOMINAL DI ATAS. KIRIMKAN BUKTI PEMBAYARAN ANDA DI BAWAH. DAN MASUKKAN NAMA PENGIRIM DI KOLOM KETERANGAN.</p>
       <form onSubmit={handleSubmit}>
 <div>
   <p style={{ marginBottom: '0.2rem' }}>Bukti Transfer</p>
   <input
     type="file"
     onChange={handleFileChange}
     style={{
       color: 'black',
       width: '90%',
       border: '1px solid #d9d9d9',
       borderRadius: '5px'
     }}
     required
   />
   <p style={{color:'red',marginBottom:'1rem',fontSize:'0.8rem'}}>{msgError.file}</p>

 </div>
 <div>
   <p style={{ marginBottom: '0.2rem' }}>Keterangan</p>
   <textarea name='keterangan' value={keterangan} onChange={((e) => setKeterangan(e.target.value))}
     style={{
       color: 'black',
       width: '90%',
       border: '1px solid #d9d9d9',
       borderRadius: '5px',
       height: '6rem',
       padding: '1rem',
     }}
     required
   />
   <p style={{color:'red',marginBottom:'1rem',fontSize:'0.8rem'}}>{msgError.keterangan}</p>
 </div>
 <div style={{ textAlign: 'center' }}>
   <button
     style={{
       textDecoration: 'none',
       padding: '8px',
       borderRadius: '5px',
       backgroundColor: '#3cb95d',
       fontWeight: '600',
       gap: '0.5rem',
       width: '12rem',
       border: 'none',
       fontSize: '1rem',
       marginTop: '1rem',
     }}
     type="submit"
     disabled={loading}>{loading ? <div className= 'spinner'></div> : 'Kirim Bukti Pembayaran'}
   </button>
 </div>
</form>

     </div>
   </div>)}</div>}
    </div>
    <div>
      <div>
        </div>
        <div>
            </div>
            </div>
        <Footer/>
    </div>
  )
}

export default Payment